import React, { useEffect, useMemo, useRef, useContext, useState, useCallback } from 'react';
import { ReadingStep, MultipleChoice, VideosStep, Resources, AssignmentStep, AssignmentPicker, StepNavigation } from "../components/ModulesElements";
import ModuleCompletedPopup from "../components/ModuleCompletedPopup"
import CourseCompletedPopup from "../components/CourseCompletedPopup"

import { ModulePageLayout } from "./modules.styles";
import { useNavigate, useParams } from 'react-router-dom';

import { debounce } from "lodash";

const modulesPath = ["introduction", "videos", "resources", "assignments"];


// Main Module Component
const ModulePage = () => {
  const { moduleId } = useParams();
  const navigate = useNavigate();

  const [moduleSteps, setModuleSteps] = useState([]);
  const [currentModule, setCurrentModule] = useState();
  const [loading, setLoading] = useState(true);
  const [showAnimation, setShowAnimation] = useState("");

  const courseId = useRef(null);
  const moduleIndex = useRef(null);
  const lastModule = useRef(false);
  const modulesCount = useRef(null);

  // useEffect(() => {
  //   // Load Lottie Player script
  //   const script = document.createElement('script');
  //   script.src = 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
  //   script.async = true;
  //   document.head.appendChild(script);

  //   return () => {
  //     // Only remove if script exists to avoid errors
  //     if (document.head.contains(script)) {
  //       document.head.removeChild(script);
  //     }
  //   };
  // }, []);

  useEffect(() => {
    (async function () {
      if (!moduleId) { return; }
      // console.log("props", moduleId)
      const mongoUrl = new URL(`https://bridge.hackernoon.com/p/courses`);
      // const mongoUrl = new URL(`http://localhost:8087`);
      
      const firebase = (await import("firebase/app")).default;

      if (!firebase.auth().currentUser) return;

      const token = await firebase.auth().currentUser.getIdToken();

      // console.log("yooo", token)

      try {
        const req = await fetch(mongoUrl?.toString(), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const response = await req.json();

        // console.log("Service Response", response);
        if (response?.ok === true) {
          // console.log("heree", response);
          courseId.current = response?.course?._id;
          const modules = response?.course?.modules || [];
          const index = modules?.findIndex(item => item?._id === moduleId);
          if (index >= 0) {
            moduleIndex.current = index;
            setCurrentModule(modules[index]);
            const steps = createModuleSteps(modules[index]);
            setModuleSteps(steps);
            if(index + 1 === modules?.length){
              const modulesCountObj = getModulesCount(modules);
              lastModule.current = true;
              modulesCount.current = modulesCountObj;
            }
          }
          // setCurrentModule(response?.course);
        }else {
          navigate("/my-courses");
        }
      } catch (e) {
        console.log("something went wrong!", e);
        navigate("/my-courses");
      }
      setLoading(false);
    })()
  }, [])

  const getModulesCount = (modules = []) => {
    const fields = ["videos", "resources", "assignments"];
    const obj = {
      modules: modules?.length
    }
    modules?.forEach(module => {
      fields.forEach(field => {
        // console.log("doing field", field);
        const item = module[field] || [];
        
        item.forEach(temp => {
          if(obj[field]){
            obj[field] = obj[field] + 1;
          }else{
            obj[field] = 1;
          }
          if(temp?.multipleChoice){
            temp?.multipleChoice?.forEach(mc => {
              if(obj["multipleChoice"]){
                obj["multipleChoice"] = obj["multipleChoice"] + 1;
              }else{
                obj["multipleChoice"] = 1;
              }
            })
          }
        })
      });
    });
    return obj;
  }

  const completeSection = async (path) => {
    if (!moduleId) { return; }
    // console.log("props", moduleId)
    const mongoUrl = new URL(`https://bridge.hackernoon.com/p/courses/module-section-complete`);
    // const mongoUrl = new URL(`http://localhost:8087/module-section-complete`);
    const firebase = (await import("firebase/app")).default;

    if (!firebase.auth().currentUser) return;

    const token = await firebase.auth().currentUser.getIdToken();

    try {
      await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({path, moduleId, courseId: courseId?.current})
      });
    
    } catch (e) {
      console.log("something went wrong!", e);
    }
  }

  const handleModuleFinish = async () => {
    if (!moduleId) { return; }
    // console.log("props", moduleId)
    // const mongoUrl = new URL(`http://localhost:8088/module-complete`);
    const mongoUrl = new URL(`https://bridge.hackernoon.com/p/courses/module-complete`);
    const firebase = (await import("firebase/app")).default;

    if (!firebase.auth().currentUser) return;

    const token = await firebase.auth().currentUser.getIdToken();

    try {
      const res = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({moduleId, courseId: courseId?.current, completeCourse: lastModule?.current, moduleNumber: moduleIndex?.current + 1})
      });

      const response = await res.json();
      if(response?.ok){
        if(lastModule?.current){
          setShowAnimation("course-completed");
        }else {
          setShowAnimation("module-completed");
          setTimeout(() => {
            setShowAnimation("");
            navigate("/my-courses");
          }, 4000);
        }
      }
    
    } catch (e) {
      console.log("something went wrong!", e);
    }
  }

  const createModuleSteps = (module) => {
    if (!module) return [];

    let steps = [];
    let currentStepFound = false;
    let stepIndex = 0;

    modulesPath.forEach(item => {
      if (item === "introduction") {
        stepIndex++;
        const completed = module?.introductionCompleted === true;
        steps.push({
          index: stepIndex,
          type: "introduction",
          completed,
          current: !completed && !currentStepFound
        });
        if (!completed && !currentStepFound) currentStepFound = true;
      }

      if (item === "assignments") {
        let assignments = module["assignments"] || [];
        assignments.forEach(({ completed = false, _id }) => {
          stepIndex++;
          steps.push({
            index: stepIndex,
            type: `assignments.${_id}`,
            completed,
            current: !completed && !currentStepFound
          });
          if (!completed && !currentStepFound) currentStepFound = true;
        });
      }

      if (item === "videos") {
        let moduleParts = module[item] || [];
        moduleParts?.forEach(({ completed = false, multipleChoice, _id }, i) => {
          stepIndex++;
          steps.push({
            index: stepIndex,
            type: `${item}.${_id}`, // "video" | "resource"
            completed,
            current: !completed && !currentStepFound
          });
          
          if (!completed && !currentStepFound) currentStepFound = true;

          if (multipleChoice && multipleChoice.length > 0) {
            multipleChoice.forEach((q, j) => {
              stepIndex++;
              const qCompleted = q?.completed === true;
              steps.push({
                index: stepIndex,
                type: `${item}.${_id}.multipleChoice.${q?._id}`,
                completed: qCompleted,
                current: !qCompleted && !currentStepFound
              });
              if (!qCompleted && !currentStepFound) currentStepFound = true;
            });
          }
        });
      }

      if (item === "resources") {
        let moduleParts = module[item] || [];
        if(moduleParts?.length > 0){
          const allCompleted = moduleParts.every(obj => obj.completed === true);

          stepIndex++;
            steps.push({
            index: stepIndex,
            type: `${item}`,
            completed: allCompleted,
            current: !allCompleted && !currentStepFound
          });
        }
        moduleParts?.forEach(({ completed = false, multipleChoice, _id }, i) => {
          if (multipleChoice && multipleChoice.length > 0) {
            multipleChoice.forEach((q, j) => {
              stepIndex++;
              const qCompleted = q?.completed === true;
              steps.push({
                index: stepIndex,
                type: `${item}.${_id}.multipleChoice.${q?._id}`,
                completed: qCompleted,
                current: !qCompleted && !currentStepFound
              });
              if (!qCompleted && !currentStepFound) currentStepFound = true;
            });
          }
        });
      }
    });

    const hasCurrent = steps?.some(step => step?.current === true);
    if(!hasCurrent){
      const lastIndex = steps?.length - 1;
      steps[lastIndex].current = true;
    }


    return steps;
  };

  const handleCompleteAndNext = (step) => {
    const arr = [...moduleSteps];
    const index = arr?.findIndex(item => item?.index === step);
    if (index < 0) { return; }

    if(!arr[index].completed){
      arr[index].completed = true;
      completeSection(arr[index]?.type)
    }
      // setCanHitNext(false);
    
    arr[index].current = false;
    arr[index + 1].current = true;    

    setModuleSteps([...arr]);
  };

  const handleNext = (step) => {
    const arr = [...moduleSteps];
    const index = arr?.findIndex(item => item?.index === step);
    if (index < 0) { return; }
      // setCanHitNext(false);
    
    arr[index].current = false;
    arr[index + 1].current = true;    

    setModuleSteps([...arr]);
  };

  const handlePreview = (step) => {
    const arr = [...moduleSteps];
    const index = arr?.findIndex(item => item?.index === step);
    if (index < 0) { return; }
      // setCanHitNext(false);
    
    arr[index].current = false;
    arr[index - 1].current = true;    

    setModuleSteps([...arr]);
  };

  const handleMarkCompleted = (step) => {
    const arr = [...moduleSteps];
    const index = arr?.findIndex(item => item?.index === step);
    // console.log("heree22", step, index, arr)
    if (index < 0) { return; }

    arr[index].completed = true;
    completeSection(arr[index]?.type);
    setModuleSteps([...arr]);
  }

  const handleSaveAssignment = async (assignmentId, html = "") => {
    const url = new URL(`https://bridge.hackernoon.com/p/courses/save-assignment`);
    // const url = new URL(`http://localhost:8088/save-assignment`);

    if(!currentModule?._id || !courseId?.current || !assignmentId) return;

    url.searchParams.append("moduleId", currentModule?._id);
    url.searchParams.append("courseId", courseId?.current);
    url.searchParams.append("assignmentId", assignmentId);

    const firebase = (await import("firebase/app")).default;

    const {currentUser} = firebase.auth();
    if (!currentUser) {
      console.log("You must be logged first");
      return;
    }

    const token = await currentUser.getIdToken();

    try {
      await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({htmlContent: html}),
      });
      // const response = await res.json();
      // console.log("Service Response", response);
    } catch (e) {
      console.log("something went wrong", e);
    }
  }
    

  const debounceSaveAssignment = useCallback(
    debounce((html, assignmentId) => {
      try {
        handleSaveAssignment(assignmentId, html);
      } catch (e) {
        console.log("something with auto save", e);
      }
    }, 1000),
  );

  const renderedStep = useMemo(() => {
    const arr = [...moduleSteps];
    const currentSection = arr?.filter(item => item?.current)[0];
    if (!currentSection) return null;

    const type = currentSection?.type;
    // console.log("currentSection", currentSection, index, type)

    if (type === "introduction") return <ReadingStep module={currentModule} />;
    if (type.startsWith("videos")) {
      if (type.includes("multipleChoice")) {
        return <MultipleChoice key={currentSection?.type} path={currentSection?.type} completed={currentSection?.completed} module={currentModule} markComplete={() => handleMarkCompleted(currentSection?.index)} />;
      } else {
        return <VideosStep 
          key={currentSection?.type} 
          path={currentSection?.type} 
          videos={currentModule?.videos} 
          markComplete={() => handleMarkCompleted(currentSection?.index)} 
        />;
      }
    }
    if (type.startsWith("resources")) {
      if (type.includes("multipleChoice")) {
        return <MultipleChoice key={currentSection?.type} path={currentSection?.type} completed={currentSection?.completed} module={currentModule} markComplete={() => handleMarkCompleted(currentSection?.index)} />;
      } else {
        return <Resources  key={currentSection?.type} resources={currentModule?.resources} markComplete={() => handleMarkCompleted(currentSection?.index)} completed={currentSection?.completed} />;
      }
    }
    if (type.startsWith("assignments")) {
      return (
        <AssignmentPicker 
          moduleNumber={moduleIndex?.current + 1}
          path={currentSection?.type} 
          assignments={currentModule?.assignments} 
          completed={currentSection?.completed} 
          canHitNext={() => !currentSection?.completed && handleMarkCompleted(currentSection?.index)} 
          debounceSaveAssignment={debounceSaveAssignment}
        />
      );
    }

    return null;
  }, [moduleSteps, currentModule]);

  if(loading) { 
    return (
      <div className="loading-component">
        <lottie-player 
          src="/loader_lottie.json" 
          background="transparent" 
          speed="1" 
          style={{width: '300px', height: '300px'}}
          loop 
          autoplay>
        </lottie-player>
      </div>
    )
  }
  if(!currentModule) { return null; }


  // console.log(lastModule.current)
  return (
    <ModulePageLayout>
      <StepNavigation
        steps={moduleSteps}
        moduleCompleted={currentModule?.completed}
        moduleTitle={currentModule?.title || ""}
        completeAndNext={handleCompleteAndNext}
        exit={() => navigate("/my-courses")}
        next={handleNext}
        preview={handlePreview}
        finish={handleModuleFinish}
      />

      <div className="course-steps">
        {renderedStep}
      </div>

      <ModuleCompletedPopup 
        trigger={showAnimation === "module-completed"} 
        imageSrc={`https://cdn.hackernoon.com/courses/svg/module-${moduleIndex?.current + 1}.svg`}
        badgeNumber={moduleIndex?.current + 1}
      />
      <CourseCompletedPopup 
        isOpen={showAnimation === "course-completed"} 
        // isOpen={true}
        modulesCount={modulesCount?.current} 
        imageSrc={`https://cdn.hackernoon.com/courses/svg/module-${moduleIndex?.current + 1}.svg`}
        goTo={(path) => navigate(path)}
     />
    </ModulePageLayout>
  );
};

export default ModulePage;